

const blogs = [
    {
        id: 1,
        title: "Best Halal Indian Restaurants in London for Foodies & First-Timers",
        slug: "best-halal-indian-restaurants-in-london-for-foodies-and-first-timers",
        date: "August 24, 2025",
        author: "Food Guide Team",
        featuredImage: "/blog1.jpg",
        alt: "Halal Indian cuisine in London",
        introduction: `London is a melting pot of cultures and cuisines and the halal Indian food scene is one of the most exciting. 
      Whether someone is searching for "halal Indian restaurant near me" or "halal Indian restaurant London", this guide highlights five standout spots.`,

        restaurants: [
            {
                name: "Wok & Fire – Build Your Own Halal Fusion Delight",
                interior: "Clean, vibrant, cozy dine-in or grab-and-go experience",
                foodHighlights: [
                    "Crunchy chips",
                    "Crispy fried chicken",
                    "Saucy noodles",
                    "Spicy curry",
                    "Cheesy corn dog",
                    "Chicken drumstick & wings",
                    "Cold drinks",
                ],
                whyVisit: "Excellent for foodies who appreciate customized flavor combos. Great for first-timers. Affordable, quick, and open late in several London locations.",
            },
            {
                name: "Gymkhana (Mayfair) – Refined Mughlai Sophistication",
                interior: "Elegant, plush, with colonial Indian club inspiration",
                foodHighlights: ["Biryani", "Curries", "Grilled Kebabs", "Tikkas"],
                whyVisit: "One of the best halal Indian restaurants, delivering a polished, flavor-rich experience for both seasoned food lovers and newcomers.",
            },
            {
                name: "Dishoom – Nostalgic Bombay Cafe Charm",
                interior: "Retro decor, bustling cafe vibe",
                foodHighlights: ["House Black Daal", "Chicken Ruby", "Naan Rolls", "Lamb Bacon Breakfast Roll"],
                whyVisit: "Perfect for those searching for 'halal Indian restaurant near me', with comforting, flavorful dishes for first-timers and foodies.",
            },
            {
                name: "Tayyabs – Punjabi Street Food Legend",
                interior: "Casual, lively, and always buzzing",
                foodHighlights: ["Lamb Chops", "Chicken Karahi", "Mixed Grills"],
                whyVisit: "Unbeatable for authentic, affordable, and hearty Punjabi cuisine, often the first result for 'halal Indian near me'.",
            },
            {
                name: "Benares – Modern Fine Dining with Halal Flair",
                interior: "Chic, upscale, with subtle Indian accents",
                foodHighlights: ["Lucknowi-style curries", "Fusion desserts", "Creatively plated small plates"],
                whyVisit: "A luxury experience for foodies seeking culinary artistry and first-timers looking for a refined introduction to halal Indian cuisine.",
            },
        ],
    },
    {
        id: 2,
        title: "From Ramen to Chow Mein: Best Noodle Restaurants in London",
        slug: "from-ramen-to-chow-mein-best-noodle-restaurants-in-london",
        date: "August 24, 2025",
        author: "Food Guide Team",
        featuredImage: "/blog2.jpg",
        alt: "Noodle dishes in London",
        introduction: `London has always been a city where food trends travel fast. Recently, the spotlight has shifted toward authentic noodle restaurants from fiery Chongqing bowls to delicate crab roe noodles of Jiangnan.`,

        restaurants: [
            {
                name: "Wok & Fire – Halal & Quick-Serve Comfort",
                interior: "Modern noodle restaurant with build-your-own bowls, friendly casual vibe",
                foodHighlights: ["Halal-certified meats", "Fresh vegetables", "Customizable sauces"],
                price: "£10–£15",
                whyVisit: "Quick service, casual vibe, and perfect for office workers or students.",
            },
            {
                name: "Lanzhou Lamian Noodle Bar – Hand-Pulled Classics",
                interior: "Heart of Covent Garden, open kitchen with hand-pulled noodles",
                foodHighlights: ["Handmade noodles", "Slow-simmered beef broth", "Chili oil & herbs"],
                price: "£12–£18",
                whyVisit: "Authentic northern Chinese flavors and visually engaging noodle pulling.",
            },
            {
                name: "Xi’an BiangBiang Noodles – Wide & Spicy Belts",
                interior: "Aldgate East, casual and vibrant",
                foodHighlights: ["Broad wheat noodles", "Cumin beef", "Chili oil"],
                price: "£10–£14",
                whyVisit: "Ideal for adventurous eaters who want something different from ramen or pad Thai.",
            },
            {
                name: "Master Wei Xi’an Cuisine – Refined Shaanxi Flavors",
                interior: "Holborn, polished sit-down experience",
                foodHighlights: ["Beef and vegetable biangbiang noodles", "Soy-bean sauce toppings"],
                price: "£12–£16",
                whyVisit: "Bold flavors in a calmer dining setting.",
            },
            {
                name: "Liu Xiaomian – Spicy Chongqing Hits",
                interior: "Kingly Court, Carnaby, compact and lively",
                foodHighlights: ["Sichuan peppercorn", "Minced pork", "Chili broth"],
                price: "£12–£15",
                whyVisit: "Fiery bowls perfect for spice lovers.",
            },
            {
                name: "Song He Lou – Jiangnan Elegance in Chinatown",
                interior: "Wardour Street, refined and elegant",
                foodHighlights: ["Crab roe noodles", "Eel noodles", "Delicate seafood"],
                price: "£28–£34",
                whyVisit: "Polished experience, ideal for tourists or office workers treating themselves.",
            },
        ],
    },
];

export default blogs;
